// const ReactGA = require('react-ga');

export const initGA = (gaId) => {
  console.log('GA init');
  // ReactGA.initialize(gaId);
};

export const logPageView = () => {

  // console.log(`Logging pageview for ${window.location.pathname}${window.location.search}`);
  // ReactGA.set({ page: `${window.location.pathname}${window.location.search}` });
  // ReactGA.pageview(`${window.location.pathname}${window.location.search}`);
};

export const logEvent = (category = '', action = '', label) => {
  return;
  if (category && action && label) {
    // ReactGA.event({ category, action, label });
  } else if (category && action) {
    // ReactGA.event({ category, action });
  }
};

export const logException = (description = '', fatal = false) => {
  if (description) {
    // ReactGA.exception({ description, fatal });
  }
};
